module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-order/manage-order.component.css
// module id = ./src/app/manage-order/manage-order.component.css
// module chunks = main